export default __webpack_public_path__ + "static/media/check.96fc814c.svg";